import * as yup from 'yup';

const hoy = new Date();
hoy.setHours(23, 59, 59, 999);

const noFuturo = (msg) => {
  return yup.string().test('no-future', msg || 'La fecha no puede ser futura', (val) => {
    if (!val) return true;
    return new Date(val) <= hoy;
  });
};

export const generalSchema = yup.object().shape({
  nombres: yup.string().required('El nombre es requerido'),
  apellidos: yup.string().required('El apellido es requerido'),
  fecha: noFuturo('Fecha de nacimiento inválida').required('Fecha de nacimiento requerida'),
  email: yup.string().email('Email inválido').required('Email requerido'),
  telefono: yup.string().min(7, 'Mínimo 7 dígitos').required('Teléfono requerido'),
  departamento: yup.string().required('Departamento requerido'),
  municipio: yup.string().required('Municipio requerido'),
  profesion: yup.string().required('Profesión requerida'),
  oficio: yup.string().required('Oficio requerido'),
  habilidades: yup.array().min(1, 'Agrega al menos una habilidad técnica').required('Requerido'),
});

export const experienceSchema = yup.object().shape({
  cargo: yup.string().required('El cargo es requerido'),
  empresa: yup.string().required('La empresa es requerida'),
  tipoEmpleo: yup.string().required('Tipo de empleo requerido'), // NUEVO
  modalidad: yup.string().required('Modalidad requerida'), // NUEVO (Recomendado)
  fechaInicio: noFuturo().required('Fecha de inicio requerida'),
  fechaFin: yup.string().when('actualmente', {
    is: true,
    then: (schema) => schema.nullable().notRequired(),
    otherwise: (schema) =>
      schema
        .required('Fecha fin requerida')
        .test('no-future', 'La fecha no puede ser futura', (val) => {
          if (!val) return true;
          return new Date(val) <= hoy;
        })
        .test('rango-valido', 'La fecha fin debe ser posterior a la de inicio', function (val) {
          const { fechaInicio } = this.parent;
          if (!fechaInicio || !val) return true;
          return new Date(val) >= new Date(fechaInicio);
        }),
  }),
});

export const educationSchema = yup.object().shape({
  institucion: yup.string().required('Institución requerida'),
  titulo: yup.string().required('Título obtenido requerido'),
  fechaInicio: noFuturo().required('Fecha de inicio requerida'),
  fechaFin: noFuturo()
    .required('Fecha de finalización requerida')
    .test('rango-valido', 'La fecha fin debe ser posterior a la de inicio', function (val) {
      const { fechaInicio } = this.parent;
      if (!fechaInicio || !val) return true;
      return new Date(val) >= new Date(fechaInicio);
    }),
});

export const validateData = async (schema, data) => {
  try {
    await schema.validate(data, { abortEarly: false });
    return {};
  } catch (err) {
    const newErrors = {};
    err.inner.forEach((error) => {
      newErrors[error.path] = error.message;
    });
    return newErrors;
  }
};
